import { DOCUMENT } from '@angular/common';
import { ComponentRef, Inject, Injectable, Type, ViewContainerRef } from '@angular/core';
import { ModalOverlayComponent } from '@app/layout/components/modal-components/modal-overlay/modal-overlay.component';
type DialogMap = Record<string, ComponentRef<unknown>>;

@Injectable()
export class BaseModalService {
  private vc!: ViewContainerRef;

  private dialogMap: DialogMap = {};
  private overlayComponentRef: ComponentRef<ModalOverlayComponent> | null = null;
  private nextDialogId = 0;
  private previousFocus: HTMLElement | null = null;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  open<T extends { id: string }>(component: Type<T>): ComponentRef<T> {
    if(!this.overlayComponentRef) {
      this.previousFocus = this.document.activeElement instanceof HTMLElement ? this.document.activeElement : null;
      this.overlayComponentRef = this.vc.createComponent(ModalOverlayComponent);
      this.overlayComponentRef.instance.backdropClick.subscribe(() => this.closeTop());
      this.document.body.style.overflow = 'hidden';
    }
    const dialogRef = this.vc.createComponent(component);
    dialogRef.instance.id = `dialog-${this.nextDialogId++}`;
    this.dialogMap[dialogRef.instance.id] = dialogRef;
    return dialogRef;
  }

  close(id: string): void {
    const dialog = this.dialogMap[id];
    if (!dialog) return;
    dialog.destroy();
    delete this.dialogMap[id];
    if(Object.keys(this.dialogMap).length === 0 && this.overlayComponentRef) {
      this.overlayComponentRef?.destroy();
      this.overlayComponentRef = null;
      this.document.body.style.removeProperty('overflow');
      this.previousFocus?.focus();
      this.previousFocus = null;
    }
  }

  setViewContainer(vc: ViewContainerRef): void {
    this.vc = vc;
  }

  private closeTop(): void {
    const ids = Object.keys(this.dialogMap);
    const topId = ids.at(-1);
    if (topId) this.close(topId);
  }
}
